import { css } from 'lit-element';
import { litStyle } from 'lit-element-style';


export const layoutStyles = litStyle(css`

  .smaller {
    max-width: 450px;
  }

  .content {
    padding-top: 15px;
  }

  .content-box,
  info-box,
  warning-box,
  success-box,
  box-list {
    display: block;
    box-sizing: border-box;
    margin-top: 15px;
  }

  .content-box {
    padding: 15px;
    background: #f9f9f9;
    border: 1px solid #CCC;
    border-radius: 2px;
  }

  .content-box:last-child,
  info-box:last-child {
    border-radius: 0 0 2px 2px;
  }

  .content h2,
  .content-box h2 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 15px 0;
  }

  .center {
    display: flex;
    justify-content: center;
  }

  .right {
    display: flex;
    justify-content: end;
  }

  .spread {
    display: flex;
    justify-content: space-between;
  }

  @media screen and (max-width: 500px) {

    .content {
      padding: 15px;
    }

    .content-box,
    info-box,
    warning-box,
    success-box,
    box-list {
      margin-top: 0;
      margin-bottom: 0;
      border-radius: 0;
      border-width: 0;
    }

    .content-box:last-child,
    info-box:last-child {
      border-top-width: 0;
    }

    .root {
      padding-left: 15px;
      padding-right: 15px;
    }

  }

`);
